import { render, staticRenderFns } from "./AccountOrders.vue?vue&type=template&id=3926abb8&scoped=true&"
import script from "./AccountOrders.vue?vue&type=script&lang=js&"
export * from "./AccountOrders.vue?vue&type=script&lang=js&"
import style0 from "./AccountOrders.vue?vue&type=style&index=0&id=3926abb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3926abb8",
  null
  
)

export default component.exports